import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FaSearch,
    FaUserTie,
    FaPlusCircle,
    FaTasks,
    FaUsers,
    FaUserCircle
} from 'react-icons/fa';
import { DataProvider } from '../../store/ContextProvider';
import { fetchEmployerMetrics } from '../../services/Employer Portal/employerMetrics';

const cardsConfig = [
    { key: 'searchCandidates', title: 'Search Candidates', icon: <FaSearch size={24} />, route: '/list-candidates' },
    { key: 'proSearch', title: 'Pro Search Candidates', icon: <FaUserTie size={24} />, route: '/pro-search' },
    { key: 'createJobs', title: 'Create Jobs', icon: <FaPlusCircle size={24} />, route: '/create-job' },
    { key: 'manageJobs', title: 'Job Management', icon: <FaTasks size={24} />, route: '/list-jobs' },
    { key: 'applicants', title: 'Job Applicants', icon: <FaUsers size={24} />, route: '/job-applications' },
    { key: 'account', title: 'My Account', icon: <FaUserCircle size={24} />, route: '/my-account' },
];

export default function EmployerDashboard() {
    const navigate = useNavigate();
    const { BeURL, showAlert } = useContext(DataProvider);
    const [counts, setCounts] = useState({})

    useEffect(() => {
        if (BeURL) {
            fetchEmployerMetrics(BeURL, showAlert, setCounts)
        }
    }, [BeURL]);

    return (
        <div className='min-h-[80vh]'>
            <h2 className='my-5 text-center text-2xl font-semibold text-slate-800'>Employer Dashboard</h2>

            <div className=' flex justify-end mb-5 px-16'>

                <button className='rounded-full px-4 py-1 text-md bg-primary-500 hover:bg-primary-600 text-white' onClick={() => navigate('/view-newcomer')}>New Candidates</button>
            </div>

            <div className="p-6 flex flex-wrap justify-center items-stretch gap-6" style={{ alignContent: 'center' }}>
                {cardsConfig.map(card => (
                    <div
                        key={card.key}
                        onClick={() => navigate(card.route)}
                        className="flex flex-col items-center justify-between w-full sm:w-[48%] lg:w-[30%] bg-white rounded-2xl shadow-lg hover:shadow-xl transition p-6 cursor-pointer"
                    >
                        <div className="p-4 rounded-full bg-blue-100 text-primary-500 mb-4">
                            {card.icon}
                        </div>
                        <h3 className="text-3xl font-bold text-slate-600">
                            {counts[card.key] ?? ''}
                        </h3>
                        <p className="text-primary-400 mt-2 text-center text-lg font-medium">{card.title}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}
